module.exports = __webpack_public_path__ + "static/img/zhuhai.4db31b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhuhai.jpg
// module id = 1y5z
// module chunks = 1